export const getBrandName = (car_id, carBrands, fallback = "ยี่ห้อรถยนต์") => {
  if (!car_id) return fallback;
  const brand = carBrands.find((b) => b.id === car_id);
  return brand ? brand.name : fallback;
};
